module.exports = __webpack_public_path__ + "img/cs-iosC-5.37a287e8.jpg";